import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as config from "../../../../constants/config";
import * as customTabActions from "../../../../actions/customTabActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as colorHelper from "../../../../helpers/colorHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Input from "../../../global/generic/Input";
import Modal from "../../../global/generic/Modal";
import Rgb from "../../../../models/utils/Rgb";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";

class EditFormulaRgbModal extends Component {
    constructor(props) {
        super(props);

        let rgb = new Rgb(0, 0, 0);

        if (this.props.formula !== null && this.props.formula.rgb !== null) {
            rgb.hex = this.props.formula.rgb;
        }

        this.state = {
            rgb: rgb,
            localData: false
        };
    }

    componentDidMount() {
        if (this.props.formula !== null) {
            this.setState({localData: this.props.formula.color.local});
        }
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleRedChange = (event) => {
        this.setState({
            rgb: this.state.rgb.updateRed(Number(event.target.value))
        });
    };

    handleGreenChange = (event) => {
        this.setState({
            rgb: this.state.rgb.updateGreen(Number(event.target.value))
        });
    };

    handleBlueChange = (event) => {
        this.setState({
            rgb: this.state.rgb.updateBlue(Number(event.target.value))
        });
    };

    handleEditRgbClick = () => {
        this.props.dispatchEditFormulaRgbAction(this.props.tabId, this.state.rgb.hex);
        this.props.dispatchCloseModalAction();
    };

    handleGenerateRgbClick = () => {
        if (this.props.formula === null || this.props.formula.realColorantList.length === 0) {
            this.setState({
                rgb: this.state.rgb.updateHex(config.DEFAULT_RGB)
            });
        } else {
            this.setState({
                rgb: this.state.rgb.updateHex(colorHelper.generateRgbByColorants(this.props.formula.realColorantList))
            });
        }
    };

    getGenerateButton = () => {
        if (this.props.generateColorPreview) {
            return null;
        }

        return (
            <Button
                className={"s-btn"}
                onClick={this.handleGenerateRgbClick}
                label={<Translate value="editFormulaRgbModal.tryGenerateRgb" />}
            />
        );
    };

    getContent = () => {
        if (this.props.formula === null) {
            return null;
        }
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex flex-gap-10px">
                    <div className="col-3 flex flex-align-center-vertical">
                        {translate("editFormulaRgbModal.red")}: {this.state.rgb.red}
                    </div>
                    <Input
                        className="fill-flex-space primary-input"
                        type="range"
                        value={this.state.rgb.red}
                        onChange={this.handleRedChange}
                        elementProps={{
                            min: "0",
                            max: "255",
                            step: "1"
                        }}
                    />
                </div>
                <br />
                <div className="col-12 flex flex-gap-10px">
                    <div className="col-3 flex flex-align-center-vertical">
                        {translate("editFormulaRgbModal.green")}: {this.state.rgb.green}
                    </div>
                    <Input
                        className="fill-flex-space primary-input"
                        type={"range"}
                        min={"0"}
                        max={"255"}
                        value={this.state.rgb.green}
                        onChange={this.handleGreenChange}
                    />
                </div>
                <br />
                <div className="col-12 flex flex-gap-10px">
                    <div className="col-3 flex flex-align-center-vertical">
                        {translate("editFormulaRgbModal.blue")}: {this.state.rgb.blue}
                    </div>
                    <Input
                        className="fill-flex-space primary-input"
                        type={"range"}
                        min={"0"}
                        max={"255"}
                        value={this.state.rgb.blue}
                        onChange={this.handleBlueChange}
                    />
                </div>
                <br />
                <div
                    className="margin-top-10 width-100"
                    style={{backgroundColor: this.state.rgb.hex, height: "150px"}}
                />
                <div className="padding-top-10">{this.getGenerateButton()}</div>
            </React.Fragment>,
            "flex-row-gap-10px flex-wrap slim-scroll col-12"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    className={"margin-right-5"}
                    onClick={this.handleEditRgbClick}
                    label={<Translate value="editFormulaRgbModal.apply" />}
                    svgBefore={imgConfirm}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        return (
            <Modal
                className={this.state.localData ? "custom-formula" : ""}
                modlId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="editFormulaRgbModal.modalLabel" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (ownProps.tabId === undefined || store.formula[ownProps.tabId] === undefined) {
        return {
            formula: null,
            generateColorPreview: store.settings.generateColorPreview
        };
    }

    return {
        formula: store.formula[ownProps.tabId].formula,
        generateColorPreview: store.settings.generateColorPreview
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchEditFormulaRgbAction: (tabId, rgb) => {
            dispatch(customTabActions.editFormulaRgb(tabId, rgb));
        },
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_FORMULA_RGB_MODAL));
        }
    };
};

export default EditFormulaRgbModal = connect(mapStoreToProps, mapDispatchToProps)(EditFormulaRgbModal);
